// cep.js — o CEP vira endereço, e o CEP do perfil vai para onde se calcula frete.
//
// ================= POR QUE UM ARQUIVO SÓ =================
//
// Três telas querem a mesma coisa: o perfil (preencher rua, bairro, cidade e
// estado a partir do CEP), a página do livro (já trazer o CEP salvo para
// calcular o frete) e o checkout. Cada uma com a sua chamada ao ViaCEP é como
// uma delas acaba tratando "CEP inexistente" de um jeito e as outras de outro.

export const soDigitosCep = (v) => String(v || "").replace(/\D/g, "").slice(0, 8);

export const mascaraCep = (v) => {
  const d = soDigitosCep(v);
  return d.length > 5 ? `${d.slice(0, 5)}-${d.slice(5)}` : d;
};

// Memo por CEP durante a visita: quem apaga um dígito e digita de novo não
// precisa esperar a rede outra vez pelo mesmo endereço.
const memo = new Map();

/**
 * Busca o endereço de um CEP no ViaCEP.
 *
 * Devolve `null` quando o CEP não existe (o ViaCEP responde 200 com
 * `{ erro: true }`, não 404 — tratar só o status deixaria passar um endereço
 * vazio como se fosse válido).
 *
 * CEP DE CIDADE PEQUENA vem sem rua e sem bairro: é um CEP único para o
 * município inteiro. Os campos voltam vazios, e quem preenche o formulário
 * tem de SÓ preencher o que veio — nunca apagar o que a pessoa já digitou com
 * um vazio.
 *
 * @returns {Promise<{endereco, bairro, cidade, estado}|null>}
 * @throws quando a rede falha (a tela decide se avisa ou fica quieta)
 */
export const buscarCep = async (cep) => {
  const d = soDigitosCep(cep);
  if (d.length !== 8) return null;
  if (memo.has(d)) return memo.get(d);

  const r = await fetch(`https://viacep.com.br/ws/${d}/json/`);
  if (!r.ok) throw new Error("Não foi possível consultar o CEP agora.");

  const j = await r.json();
  const achado = j && !j.erro
    ? {
        endereco: j.logradouro || "",
        bairro: j.bairro || "",
        cidade: j.localidade || "",
        estado: j.uf || "",
      }
    : null;

  memo.set(d, achado);
  return achado;
};
